import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from '../lib/theme';
import AppRouter from './router';
import ErrorBoundary from '../features/shared/ErrorBoundary';
import { BrowserRouter } from 'react-router-dom';

/**
 * App.jsx v2.1 - 2026-03-07
 * ✅ 修正：移除檔案結尾無效的標籤，解決建置錯誤
 * ✅ 決策：保留 BrowserRouter（配合 netlify.toml 中 _redirects 處理 SPA 路由）
 */
function App() {
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <ThemeProvider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </ThemeProvider>
      </HelmetProvider>
    </ErrorBoundary>
  );
}

export default App;